// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-list-item[data-v-aefb9480] {\n  cursor: pointer;\n  border: 1px solid var(--v-primary-base);\n  border-radius: 8px;\n  padding: 16px 12px;\n  overflow-wrap: anywhere;\n}\n.survey-list-item .trash-icon[data-v-aefb9480] {\n  min-width: 14px;\n}", ""]);
// Exports
module.exports = exports;
